import React, {useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getStudent } from "../services/scpApi";
import { setSelectedSchool, setSelectedStudent, setSelectedYearGroup } from '../slices/portalSelectedSlice';
import { useLocation } from "react-router";
import Sidebar from "../features/sidebar/Sidebar";
import User from "../features/user/User";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

const PortalLayout = ({children}) => {

    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        console.log(location);
    }, [location]);

    useEffect(() => {
        (async () => {
            // set global states from query strings if required
            const queryParams = new URLSearchParams(window.location.search);
            const studentId = queryParams.get('student');
            const schoolId = queryParams.get('school');

            if (!studentId || !schoolId) {
                return;
            }

            // set global states
            const studentData = await getStudent(studentId); 
            const studentSchool = studentData?.school || {};
            const studentYearGroup = studentData?.pupil_periods?.length > 0 ? studentData.pupil_periods[studentData.pupil_periods.length - 1]?.year_group : {};
            const studentYearGroupObj = {
                name: `Year ${studentYearGroup}`,
                year: studentYearGroup,
            }

            dispatch(setSelectedStudent(studentData));
            dispatch(setSelectedSchool(studentSchool));
            dispatch(setSelectedYearGroup(studentYearGroupObj));

            // remove query params from URL 
            const newUrl = window.location.pathname;
            navigate(newUrl, { replace: true });
        })();
    }, []);

    return (
        <div className="portal-layout">
            <div className="header">
                <div className="content-wrap">
                    <div className="content">
                        <Link to="/portal/" className="header-logo">
                            <img src={require('../assets/SCP-logo.svg').default} alt="The School Consultancy Programme" className="header-logo" />
                        </Link>
                        <User />
                    </div>
                </div>
            </div>
        
            <div className="main">
                <div className="content-wrap">
                    <div className="content">
                        <Sidebar />
                        <div className="main-page">
                            {children}
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    );
}

export default PortalLayout;
